<script setup lang="ts">
import { useRouter } from 'vue-router'

interface Props {
  id: number
  name: string
  icon: string
  icon_blue: string
  active: number
  size: string
  warning: boolean
}
defineProps<Props>()
const router = useRouter()

const handleClickMobile = (num: number) => {
  switch (num) {
    // case 1:
    //   router.push({ name: 'AppointmentWebapp' })
    //   break
    case 2:
      router.push({ name: 'Voucher' })
      break
    case 3:
      router.push({ name: 'Benefit' })
      break
    case 4:
      router.push({ name: 'Accum' })
      break
    case 5:
      router.push({ name: 'Course' })
      break
  }
}
</script>

<template>
  <div>
    <!-- Mobile -->
    <div
      class="tw-border tw-border-primary tw-shadow-md tw-w-full tw-bg-[#F0FCFF] tw-text-[#47474A] tw-rounded-xl tw-px-8 tw-py-4 tw-mb-3 tw-flex tw-items-center tw-justify-start tw-h-14 tw-cursor-pointer"
      @click="handleClickMobile(id)"
    >
      <div class="tw-w-10">
        <img :src="`/images/profile/icon/${icon}.png`" :class="size" />
      </div>
      <p class="tw-ml-3 tw-font-bold tw-text-[16px]">{{ name }}</p>
      <p
        v-if="warning"
        class="tw-text-[16px] tw-absolute tw-text-white tw-bg-error tw-right-10 tw-w-4 tw-h-4 tw-rounded-full tw-flex tw-justify-center tw-items-center"
      ></p>
    </div>
  </div>
</template>
